import { Loading } from '@carbon/react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
  /** Affiche le spinner centré en pleine page (min-h 60vh). Par défaut true. */
  fullPage?: boolean;
}

export function LoadingSpinner({
  size = 'md',
  text = 'Chargement...',
  className = '',
  fullPage = true,
}: LoadingSpinnerProps) {
  const content = (
    <Loading
      description={text}
      withOverlay={false}
      small={size === 'sm'}
      className={className}
    />
  );

  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        {content}
      </div>
    );
  }

  return content;
}
